import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { EVALUATION_LOG_XML_DATA_QUERY } from '../../queries';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import EvaluationLogXmlContentComponent from './EvaluationLogXmlContentComponent';

const EvaluationLogXmlContentContainer = ({ id }) => {
  const [openPopUp, setOpenPopUp] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const { loading, data } = useQueryWithErrorHandling(EVALUATION_LOG_XML_DATA_QUERY, {
    variables: { id },
    skip: !openPopUp
  });

  const handleTabChange = useCallback((_, value) => setTabValue(value), []);
  const handlePopUp = useCallback(
    openPopUp => () => {
      setOpenPopUp(!openPopUp);
    },
    []
  );

  return (
    <EvaluationLogXmlContentComponent
      data={data}
      tabValue={tabValue}
      onTabChange={handleTabChange}
      loading={loading}
      openPopUp={openPopUp}
      onPopUpChange={handlePopUp}
    />
  );
};

EvaluationLogXmlContentContainer.propTypes = {
  id: PropTypes.string.isRequired
};

export default EvaluationLogXmlContentContainer;
